"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _api = require("@react-google-maps/api");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _TextField = _interopRequireDefault(require("../TextField/TextField"));

var _GoogleMapApiWrapper = _interopRequireDefault(require("../GoogleMapApiWrapper/GoogleMapApiWrapper"));

var DropdownAutocomplete = (0, _styledComponents["default"])(_TextField["default"]).withConfig({
  displayName: "LocationAutocomplete__DropdownAutocomplete",
  componentId: "stgu6l-0"
})(["text-overflow:\"ellipses\";"]);

var RenderLocationAutocomplete = function RenderLocationAutocomplete(_ref) {
  var additonalProps = _ref.additonalProps,
      selectedLocationCallback = _ref.selectedLocationCallback,
      options = _ref.options,
      types = _ref.types,
      fields = _ref.fields,
      restrictions = _ref.restrictions,
      bounds = _ref.bounds,
      onLoadCallback = _ref.onLoadCallback,
      width = _ref.width,
      onFocus = _ref.onFocus,
      disabled = _ref.disabled,
      initialValue = _ref.initialValue,
      helperText = _ref.helperText,
      height = _ref.height,
      _onChange = _ref.onChange,
      error = _ref.error,
      placeholder = _ref.placeholder;

  var _useState = (0, _react.useState)(null),
      autocomplete = _useState[0],
      setAutocomplete = _useState[1];

  var _useState2 = (0, _react.useState)(initialValue || ""),
      autoCompleteInputValue = _useState2[0],
      setAutoCompleteInputValue = _useState2[1];

  var onAutocompleteLoad = function onAutocompleteLoad(ac) {
    setAutocomplete(ac);

    if (onLoadCallback) {
      onLoadCallback(ac);
    }
  };

  var _onPlaceChanged = function onPlaceChanged(e) {
    if (autocomplete !== null && selectedLocationCallback) {
      var foundPlace = autocomplete.getPlace();

      if (foundPlace.place_id) {
        selectedLocationCallback(autocomplete.getPlace());
        setAutoCompleteInputValue(autocomplete.getPlace().formatted_address);

        if (_onChange) {
          _onChange(autocomplete.getPlace().formatted_address);
        }
      }
    }
  };

  return _react["default"].createElement(_api.Autocomplete, {
    onLoad: onAutocompleteLoad,
    onPlaceChanged: function onPlaceChanged(e) {
      return _onPlaceChanged(e);
    },
    options: options,
    types: types,
    fields: fields,
    bounds: bounds,
    restrictions: restrictions
  }, _react["default"].createElement(DropdownAutocomplete, (0, _extends2["default"])({
    type: "text",
    placeholder: placeholder,
    onFocus: onFocus,
    disabled: disabled,
    helperText: helperText,
    value: autoCompleteInputValue,
    onChange: function onChange(e) {
      setAutoCompleteInputValue(e.target.value);

      if (_onChange) {
        _onChange(e.target.value);
      }
    },
    onSubmit: function onSubmit(e) {
      return console.log(e);
    },
    error: error || "",
    width: width,
    height: height
  }, additonalProps)));
};
/**
 * A input component to provide advanced autocomplete functionality to location input.
 *
 * If more than one Google API components are used on the same page, it is recommened you wrap all the API components
 * in the GoogleMapApiWrapper to avoid multiple Google API requests which can cause errors.
 *
 * Do not provide the googleApiKey prop to this component if wrapped.
 *
 * Refer to @react-google-maps/api Github documentation.
 * @summary Location autocomplete input powered by Google Map API.
 * @param {object} props - Component props
 * @param {string=} props.googleApiKey - A Google API key that must be authenticated to use the correct API's. Do not provide if this component is wrapped with GoogleMapApiWrapper.
 * @param {function=} props.onLoadCallback - A callback for when the component has loaded.
 * @param {object=} props.options - Options to be passed into the component, refer to Google Map API.
 * @param {string|number} [props.width = 200] - Width of component.
 * @param {string|number} [props.height = 50] - Height of component.
 * @param {string[]} [props.types] - Types of autocomplete results.
 * @param {string[]} [props.fields] - Fields to be returned in selected location object.
 * @param {string[]} [props.restrictions] - Restrictions on the autocomplete results presented.
 * @param {object} [props.bounds] - Geographical bounds of the autocomplete results.
 * @param {boolean} [props.disabled] - Disable input.
 * @param {string} [props.helperText] - Helper text to be displayed underneath input.
 * @param {string} [props.error] - Error text to be displayed on input.
 * @param {string} [props.initialValue] - Inital location string to be displayed within input.
 * @param {string} [props.placeholder = "Enter Location"] - Input placeholder.
 * @param {function} [props.onFocus] - Callback for when user focuses on input.
 * @param {function} [props.onChange] - Callback for when user changes input text.
 * @param {function} [props.selectedLocationCallback] - Callback for user selects location from dropdown returning location object.
 */


var LocationAutocomplete = function LocationAutocomplete(_ref2) {
  var googleApiKey = _ref2.googleApiKey,
      selectedLocationCallback = _ref2.selectedLocationCallback,
      options = _ref2.options,
      _ref2$types = _ref2.types,
      types = _ref2$types === void 0 ? [] : _ref2$types,
      _ref2$fields = _ref2.fields,
      fields = _ref2$fields === void 0 ? [""] : _ref2$fields,
      restrictions = _ref2.restrictions,
      bounds = _ref2.bounds,
      disabled = _ref2.disabled,
      helperText = _ref2.helperText,
      error = _ref2.error,
      onLoadCallback = _ref2.onLoadCallback,
      initialValue = _ref2.initialValue,
      _ref2$placeholder = _ref2.placeholder,
      placeholder = _ref2$placeholder === void 0 ? "Enter Location" : _ref2$placeholder,
      onFocus = _ref2.onFocus,
      onChange = _ref2.onChange,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? 200 : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? 50 : _ref2$height,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["googleApiKey", "selectedLocationCallback", "options", "types", "fields", "restrictions", "bounds", "disabled", "helperText", "error", "onLoadCallback", "initialValue", "placeholder", "onFocus", "onChange", "width", "height"]);

  var renderAutocompleteComponent = function renderAutocompleteComponent() {
    return _react["default"].createElement(RenderLocationAutocomplete, {
      additonalProps: props,
      selectedLocationCallback: selectedLocationCallback,
      options: options,
      types: types,
      initialValue: initialValue,
      restrictions: restrictions,
      bounds: bounds,
      onFocus: onFocus,
      helperText: helperText,
      onLoadCallback: onLoadCallback,
      placeholder: placeholder,
      fields: fields,
      error: error,
      onChange: onChange,
      disabled: disabled,
      width: width,
      height: height
    });
  };

  if (googleApiKey) {
    return _react["default"].createElement(_GoogleMapApiWrapper["default"], {
      googleApiKey: googleApiKey
    }, renderAutocompleteComponent());
  }

  return renderAutocompleteComponent();
};

var _default = LocationAutocomplete;
exports["default"] = _default;